const TurboFlashHelper = class {
  constructor() {
    document.addEventListener('turbo:before-fetch-response', (event) => {
      try {
        // 先にflashメッセージを出す
        const flashMessages = event.detail.fetchResponse.header('X-Flash-Messages');

        // flash messageが存在する場合は表示する
        if (flashMessages !== '{}') {
          console.log('flash message found');
          const messages = JSON.parse(flashMessages);
          console.log(messages);
          for (const key in messages) {
            try {
              const message = decodeURIComponent(messages[key]);
              console.log(`${key}:${message}`);
              flash_submit(key, message);
            } catch (e) {
              console.error(`Failed to decode message for key ${key}:`, e);
            }
          }
        }

        // turbo frameから リダイレクトを望まれていたらリダイレクトする
        if (event.detail.fetchResponse && event.detail.fetchResponse.header('X-Turbo-Connect')) {
          const response = event.detail.fetchResponse.response;
          if (response.redirected) {
            console.log('need redirect');
            event.preventDefault();
            Turbo.visit(response.url, { action: 'replace' });
          }
        }
      } catch (e) {
        console.error('Error in turbo:before-fetch-response handler:', e);
      }
    });
  }
};
export default new TurboFlashHelper();
